import _ from 'lodash';
import {
	FieldConfiguration,
	LookupFieldConfiguration,
} from '../../api/ConfigApi';
import { FieldValues, FieldValuesMap } from '../../types/policy';

// Used in FieldEditorForm's updateFieldValue callback prop. This function will process string and string[]
// values and check for empty string and set the field name to the correct array value.
// pendingFieldValues is the FieldValuesMap of the pending(changed) values the user has entered. For example, the variable `endorsementFieldValues` in EndorsementPolicyDetails.tsx
// originalFieldValues a field FieldValuesMap that includes the original field values of the loaded FieldEditorForm. This is used to populate any match fields for Lookup fields. For example, the variable currentFieldValues inside EndorsementPolicyDetails.tsx
export const getNewFieldValues = (
	field: FieldConfiguration,
	value: FieldValues,
	pendingFieldValues: FieldValuesMap,
	originalFieldValues: FieldValuesMap,
) => {
	const val = _.isArray(value) ? value : [value];
	const newFieldValues = { ...pendingFieldValues } as FieldValuesMap;

	// Update's will return error if trying to set empty string '' as a value. Field values need to set it
	// to empty array [] if the field needs to be set to blank, e.g. for optional fields.
	if (val.some((v) => !v)) {
		newFieldValues[field.name] = val.filter((v) => !!v);
	} else {
		newFieldValues[field.name] = val;
	}

	// Add the current match value if the changed field is a lookup field.
	if (
		originalFieldValues &&
		field.type === 'lookup' &&
		(field as LookupFieldConfiguration).match
	) {
		(field as LookupFieldConfiguration).match.forEach((lookupMatch) => {
			if (!newFieldValues[lookupMatch]) {
				newFieldValues[lookupMatch] = originalFieldValues[lookupMatch];
			}
		});
	}

	return newFieldValues;
};
